// import justifiedGallery from '@js/vendor/justifiedGallery'

const SELECTORS = {
    gallery_item: '.gallery-item, .blocks-gallery-item',
    // lightbox: '.content a[href]'
}

const CLASSES = {
    portrait: 'portrait',
    gallery: 'js_gallery',

    // galleryItem: 'gallery-item',
    // blockGalleryItem: 'blocks-gallery-item',
}

export default class Gallery {
    constructor () {
        this.isLoaded = false
    }

    initialize () {
        this.gallery_item  = Array.from( document.querySelectorAll(SELECTORS.gallery_item) )
        // this.lightbox_item = Array.from( document.querySelectorAll(SELECTORS.lightbox) )

        if (this.gallery_item.length) {
        // if (this.gallery_item.length || this.lightbox_item.length) {
            const t = this
            import('smartphoto').then(function (module) {
                t.SmartPhoto = module.default
                t.init(() => {
                    new t.SmartPhoto('.' + CLASSES.gallery, {
                        arrows: true,// prev/next arrows
                        nav: false,// navigation images at the bottom
                        useOrientationApi: true,// use accelerometer to move images
                        resizeStyle: 'fit',// resize images to fill/fit on the screen
                        animationSpeed: variables.transition,// animation speed when switching images
                        forceInterval: 20// frequency to apply force to images
                    })

                    t.isInit()
                })
            })
        } else {
            this.isInit()
        }
    }

    init (cb) {
        // this.lightbox_item.forEach(elem => {
        //     var parent = elem.parentNode

        //     if (
        //         typeof elem.getAttribute('href') !== 'undefined'
        //         && elem.getAttribute('href').match(/\.(jpg|png|gif)/g)
        //         && !Util.hasClass( parent, CLASSES.galleryItem )
        //         && !Util.hasClass( parent.parentNode, CLASSES.galleryItem )
        //         && !Util.hasClass( parent, CLASSES.blockGalleryItem )
        //         && !Util.hasClass( parent.parentNode, CLASSES.blockGalleryItem )
        //     ) {
        //         Util.addClass( elem, CLASSES.gallery )
        //         this.changeLQSourceForElem(elem)
        //     }
        // })

        const l = this.gallery_item.length
        for (let i = 1; i <= l; i += 1) {
            var elem = this.gallery_item[i - 1]

            var childPortrait = elem.querySelector('.' + CLASSES.portrait)
            if (childPortrait) {
                Util.addClass( elem, CLASSES.portrait )
            }

            var childLink = elem.querySelector('a')
            if (childLink) {
                Util.addClass( childLink, CLASSES.gallery )
            }

            this.changeLQSourceForElem(elem)

            // if (i == l && cb) {
            //     cb()
            // }
        }

        if (cb) {
            cb()
        }
    }

    changeLQSourceForElem (elem) {
        // If low connection, load low quality image
        if (typeof App.isConnectionLow != 'undefined' && App.isConnectionLow ) {
            let src = elem.getAttribute('href'),
                ext = src.split('.').pop()
            src = Util.splice(src, src.indexOf('.' + ext), 0, '--low')
            elem.setAttribute('href', src)
        }
    }

    isInit () {
        this.isLoaded = true
        App.loadProgress += 1
        App.checkAppLoaded()
    }
}
